import type { DemoScenarioResolved } from 'tio-data/demo/types';
import type { DemoFixtureIdentity, DemoProductConfig, DemoScenario } from 'tio-employee/demo/types';
import {
  buildEmployerMatchFetchMatchers,
  buildEmployerMatchMatchers,
} from 'tio-employee/demo/products/employer-match-fixtures';

/**
 * Demo matchers for the "Secure Your Future" (SYF / SECURE 2.0 employer match)
 * product: the enrolled participant's match payments, loan transactions,
 * 401(k) insights, and an in-session certify. The participant/plan graph
 * itself rides the employee identity reads (identity-fixtures sideloads it
 * when the employerMatch product is selected), so this builder only serves the
 * dashboard's own data reads.
 */
export function buildEmployerMatchDemo(
  _config: Extract<DemoProductConfig, { kind: 'employerMatch' }>,
  _scenario: DemoScenario,
  _identity: DemoFixtureIdentity
): DemoScenarioResolved {
  return {
    matchers: buildEmployerMatchMatchers(),
    fetchMatchers: buildEmployerMatchFetchMatchers(),
    seed: [],
  };
}
